import { render, staticRenderFns } from "./AllocatedBackorderHistoryReports.vue?vue&type=template&id=42138253&"
import script from "./AllocatedBackorderHistoryReports.vue?vue&type=script&lang=js&"
export * from "./AllocatedBackorderHistoryReports.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports